import { PageContainer } from "@/components/shared/PageContainer";
import { PageHeader } from "@/components/shared/PageHeader";
import { SignalsTab } from "@/components/signals/SignalsTab";

export function SignalsPage() {
  return (
    <PageContainer>
      <PageHeader
        eyebrow="Manage"
        title="Signals"
        description="Suggested Intensity and Pod changes from NOS Guidance — triage, confirm, or dismiss."
      />

      <SignalsTab />
    </PageContainer>
  );
}
